<template>
  <section class="page-risk">
    <section class="search-form">
      <el-form
        inline
        ref="searchForm"
        :model="searchData"
        :rules="rules"
      >
        <el-form-item
          label="话术名称"
          prop="riskTipName"
        >
          <el-input v-model="searchData.riskTipName" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="searchData.status"
            clearable
          >
            <el-option
              v-for="item in tipStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </section>
    <section class="flex-between">
      <div>
        <yh-button
          type="primary"
          size="small"
          @click="handleSearchClick"
        >查询</yh-button>
        <yh-button
          size="small"
          @click="handleResetClick"
        >清空查询条件</yh-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click="handleAddClick"
          v-if="functionList.includes('327355730088398848')"
        >新增话术</yh-button>
      </div>
    </section>

    <el-table :data="tableData">
      <template slot="empty">{{emptyText}}</template>
      <el-table-column
        v-for="col in tableLabelList"
        :key="col.prop"
        :formatter="formatter"
        :prop="col.prop"
        :label="col.label"
      />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="feature-container">
            <span
              class="button--blue"
              @click="handleEditClick(scope.row)"
              v-if="functionList.includes('327355831032713216')"
            >编辑</span>
            <span
              class="button--red"
              @click="handleDeleteClick(scope.row)"
              v-if="functionList.includes('327355924779601920')"
            >删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </section>
</template>
<script>
import { addNav, getPagingData, getFunctionList } from '@/mixins';

export default {
  name: 'RiskTip',
  mixins: [addNav, getPagingData, getFunctionList],

  data() {
    const validateTipName = (rule, value, cb) => {
      if (value.length > 50) {
        cb(this.$MSG.M0114);
      } else {
        cb();
      }
    };
    return {
      functionList: [],
      rules: {
        riskTipName: [{ validator: validateTipName }],
      },
      tableData: [],
      emptyText: this.$LS.empty,
      tipStatusList: [{
        label: '启用',
        value: '1',
      }, {
        label: '禁用',
        value: '0',
      }],
      tipStatusMap: {
        1: '启用',
        0: '禁用',
      },
      searchData: {
        riskTipName: '',
        status: '',
      },
      searchParam: {
        riskTipName: '',
        status: '',
      },
      currentPage: 1,
      sumCount: 0,
      tableLabelList: [{
        prop: 'id',
        label: '话术ID',
        width: 200,
      }, {
        prop: 'riskTipName',
        label: '话术名称',
        width: 200,
      }, {
        prop: 'riskTipDescribe',
        label: '话术描述',
        width: 300,
      }, {
        prop: 'status',
        label: '状态',
        width: 100,
      }, {
        prop: 'createTime',
        label: '创建时间',
        width: 200,
      }, {
        prop: 'createId',
        label: '创建人ID',
        width: 200,
      }, {
        prop: 'updateTime',
        label: '修改时间',
        width: 200,
      }, {
        prop: 'updateId',
        label: '修改人ID',
        width: 200,
      }],
    };
  },
  watch: {
    currentPage: {
      immediate: false,
      handler() {
        this.getPagingData(this.$API.listRiskTip);
      },
    },
  },
  activated() {
    this.getPagingData(this.$API.listRiskTip);
  },
  methods: {
    formatter(row, col, value) {
      if (col.property === 'status') {
        return this.tipStatusMap[value] || '-';
      }
      return value || '-';
    },
    handleResetClick() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = '';
      });
    },
    handleSearchClick() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.searchParam = { ...this.searchData };
          this.getPagingData(this.$API.listRiskTip);
        }
      });
    },
    handleDeleteClick(tip) {
      this.$_yh_confirm('确定删除风险话术', '删除风险话术').then(() => {
        this.deleteRiskTip(tip.id);
      });
    },
    handleEditClick(tip) {
      this.addNav({
        path: '/edit-risk-tip',
        name: '编辑风险话术',
        query: {
          id: tip.id,
        },
      });
    },
    deleteRiskTip(id) {
      return this.$_post(this.$API.deleteRiskTip, {
        data: {
          id,
        },
      }).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success('删除成功');
          this.getPagingData(this.$API.listRiskTip);
        } else {
          this.$message.warn(res.errorMsg);
        }
      });
    },
    handleAddClick() {
      this.addNav({
        path: '/add-risk-tip',
        name: '新增风险话术',
      });
    },
  },
};
</script>
<style lang="scss">
.page-add-risk-tip {
  padding: 0 100px;

  .button--blue {
    display: inline-block;
    border: 0;
    outline: 0;
    text-align: center;
  }

  .e-span {
    color: red;
  }
  .risk-form-container {
    display: flex;
  }
  [contenteditable="true"] {
    word-break: break-all;
    word-wrap: break-word;
    line-height: 1.2;
    position: relative;
    padding: 10px 15px;
    box-sizing: border-box;
    width: 100%;
    color: #606266;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    outline: 0;
  }
  [contentEditable="true"]:empty::after {
    content: attr(placeholder);
    color: #c0c4cc;
    position: absolute;
    top: 10px;
    left: 15px;
  }
}
.el-dropdown-menu {
  max-height: 170px;
  overflow: auto;
}
</style>
